import { render } from "./m10final4Mixed_blend.vue?vue&type=template&id=1555a222&scoped=true"
import script from "./m10final4Mixed_blend.vue?vue&type=script&lang=js"
export * from "./m10final4Mixed_blend.vue?vue&type=script&lang=js"

import "./m10final4Mixed_blend.vue?vue&type=style&index=0&id=1555a222&lang=less&scoped=true"

import exportComponent from "D:\\00project\\36live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1555a222"]])

export default __exports__